import Trans from 'next-translate/Trans'
import React from 'react'

const RefNumber = ({ refNumber, createdAt }) => (
  <p className="text-12 mb-0">
    <Trans i18nKey="transaction:refNumber" />
    {' '}
    {refNumber}
    {' '}
    -
    {' '}
    {createdAt?.dT}
  </p>
)
export default RefNumber
